import axios from 'axios'

export const http = axios.create({
    baseURL: import.meta.env.VITE_API_URL,
    headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
    },
    timeout: 15000,
    withCredentials: true,
    withXSRFToken: true,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
})

import { toast } from 'sonner'
import { useSessionStore } from '../../store/auth/auth.store'

http.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 403) {
            const message = error.response.data?.message || 'No tienes permiso para acceder a este recurso.'
            const isBranchSwitch = error.config?.method === 'put'
                && error.config?.url?.endsWith('/auth/sucursal-context')

            if (isBranchSwitch) {
                return Promise.reject(error)
            }

            if (message.toLowerCase().includes('sucursal')) {
                useSessionStore.getState().setRevoked(message)
                useSessionStore.getState().setActiveBranchId(null)
            } else {
                toast.error(message)

                error.__handledByInterceptor = true
            }
        }
        return Promise.reject(error)
    }
)
